module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon23.733ad6ee.png";